<template>
<div class="chapter">
<div class="inner_page">
<p class="ct"><a href="#/Content#cd20" id="d20"><b>A</b></a></p>
<p class="h1"><b>Action</b></p>
<p class="tx">A little knowledge that <i>acts</i> is worth infinitely more than much knowledge that is idle.</p>
<p class="txr">— WM-ST-63</p>
<p class="tx">Believing is a fine thing, but placing those beliefs into execution is a test of strength. Many are those who talk like the roar of the sea, but their lives are shallow and stagnant, like the rotting marshes. Many are those who lift their heads above the mountain tops, but their spirits remain dormant in the obscurity of the caverns.</p>
<p class="txr">— SH-T-17</p>
<p class="h1"><b>Adolescence</b></p>
<p class="tx">It is said that unsophistication makes a man empty and that emptiness makes him carefree. It may be true among those who were born dead and who exist like frozen corpses; but the sensitive boy who feels much and knows little is the most unfortunate creature under the sun, because he is torn by two forces. The first force elevates him and shows him the beauty of existence through a cloud of dreams; the second ties him down to the earth and fills his eyes with dust and overpowers him with fears and darkness.</p>
<p class="txr">— BW-ST-18</p>
<p class="h1"><b>Advice</b></p>
<p class="tx">He who does not seek advice is a fool. His folly blinds him to Truth and makes him evil, stubborn, and a danger to his fellow man.</p>
<p class="txr">— WM-ST-67</p>
<p class="h1"><b>Affection</b></p>
<p class="tx">The heart’s affections are divided like the branches of the cedar tree; if the tree loses one strong branch, it will suffer but it does not die. It will pour all its vitality into the next branch so that it will grow and fill the empty place.</p>
<p class="txr">— BW-ST-93</p>
<p class="h1"><b>Age</b></p>
<p class="tx">Seek ye counsel of the aged, for their eyes have looked on the faces of the years and their ears have hearkened to the voices of Life. Even if their counsel is displeasing to you, pay heed to them.</p>
<p class="txr">— WM-ST-68</p>
<p class="h1"><b>Ambition</b></p>
<p class="tx" style="text-indent: 12em;">What good is there, pray thee tell me,</p>
<p class="tx" style="text-indent: 13em;">In jostling through the crowd in life,</p>
<p class="tx" style="text-indent: 12em;">’Mid the argumental tumult,</p>
<p class="tx" style="text-indent: 13em;">Protestation, and endless strife;<br/><br/></p>
<p class="tx" style="text-indent: 12em;">Mole-like burrowing in darkness,</p>
<p class="tx" style="text-indent: 13em;">Grasping for the spider’s thread,</p>
<p class="tx" style="text-indent: 12em;">Always thwarted in ambition,</p>
<p class="tx" style="text-indent: 13em;">Until the living join the dead?</p>
<p class="txr">— P-73</p>
<p class="h1"><b>Americans</b></p>
<p class="tx">The Americans are a mighty people who never give up or get tired or sleep or dream. If these people hate someone, they will kill him by negligence, and if they like or love a person, they will shower him with affection.</p>
<p class="txr">— SP-ST-82</p>
<p class="h1"><b>Ancestry</b></p>
<p class="tx">A man is not noble through ancestry;</p>
<p class="tx">How many noblemen are descendants of murderers?</p>
<p class="txr">— MS-74</p>
<p class="h1"><b>Anthropomorphism</b></p>
<p class="tx">The mountains, trees, and rivers change their appearance with the vicissitudes of times and seasons, as a man changes with his experiences and emotions. The lofty poplar that resembles a bride in the daytime, will look like a column of smoke in the evening; the huge rock that stands impregnable at noon, will appear to be a miserable pauper at night, with earth for his bed and the sky for his cover; and the rivulet that we see glittering in the morning and hear singing the hymn of Eternity, will, in the evening, turn to a stream of tears wailing like a mother bereft of her child.</p>
<p class="txr">— BW-ST-78</p>
<p class="h1"><b>Appearance</b></p>
<p class="tx">The appearance of things changes according to the emotions, and thus we see magic and beauty in them, while the magic and beauty are really in ourselves.</p>
<p class="txr">— BW-ST-51</p>
<p class="tx" style="text-indent: 13em;">The purpose of the spirit in the</p>
<p class="tx" style="text-indent: 13em;">Heart is concealed, and by outer</p>
<p class="tx" style="text-indent: 13em;">Appearance cannot be judged.</p>
<p class="txr">— T-372</p>
<p class="h1">Art</p>
<p class="tx">Art must be a direct communication between the artist’s imagination and that of the looker. For that reason, I avoid, so much as possible, busying the looker’s eye with too many details in order that his imagination may roam wide and far. As to the physical molds, art is forced to create for expressing itself; they must be beautiful molds. Otherwise, art defeats its purpose.</p>
<p class="txr">— KG-P-102</p>
<p class="tx">Is it really God that created Man, or is it the opposite? Imagination is the only creator, its nearest and clearest manifestation is Art; yes, art is life, life is art; all else is trite and empty in comparison.</p>
<p class="txr">— KG-P-97</p>
<p class="tx">Art is one step from the visibly known toward the unknown.</p>
<p class="txr">— MS-71</p>
<p class="h1">Artist</p>
<p class="tx">I should be a traitor to my art if I were to borrow my sitter’s eyes. The face is a marvelous mirror that reflects most faithfully the innermost of the soul; the artist’s business is to see that and portray it; otherwise he is not fit to be called an artist.</p>
<p class="txr">— KG-P-97</p>
<p class="h1"><b>Authority</b></p>
<p class="tx">Selfishness, my brother, is the cause of blind superiority, and superiority creates clanship, and clanship creates authority which leads to discord and subjugation.</p>
<p class="tx">The soul believes in the power of knowledge and justice over dark ignorance; it denies the authority that supplies the swords to defend and strengthen ignorance and oppression— that authority which destroyed Babylon and shook the foundation of Jerusalem and left Rome in ruins. It is that which made people call criminals great men; made writers respect their names; made historians relate the stories of their inhumanity in manner of praise.</p>
<p class="txr">— TL-T-8</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// A.vue?4a1743b6